// extracted by mini-css-extract-plugin
module.exports = {"textBorder":"Card__textBorder__EgNCs","imageBorder":"Card__imageBorder__WceIX","baroque_texture":"Card__baroque_texture__3_AxV"};